import { render, staticRenderFns } from "./serialNumber.vue?vue&type=template&id=3a8f3d6e&scoped=true&"
import script from "./serialNumber.vue?vue&type=script&lang=js&"
export * from "./serialNumber.vue?vue&type=script&lang=js&"
import style0 from "./serialNumber.vue?vue&type=style&index=0&id=3a8f3d6e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8f3d6e",
  null
  
)

export default component.exports